import Highcharts from 'highcharts';

export const createDefaultTooltipOptions = (
): Highcharts.TooltipOptions => ({
  enabled: true,
  useHTML: true,
  borderRadius: 5,
  shadow: false,
  backgroundColor: 'rgba(255,255,255,1)',
});
